import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Grid, Box } from '@material-ui/core';
import { Trans } from 'react-i18next';

import { Divider } from './Divider';
import { Text } from './Text';

const useStyle = makeStyles(theme => ({
  wrap: {
    padding: '0 10px',
  },
  root: {
    flexGrow: 1,
    background: theme.palette.darkGrey,
    color: theme.palette.white,
  },
  rootTop: {
    background: theme.palette.darkGrey,
    color: theme.palette.white,
  },
  right: {
    padding: '0 50px',
    [theme.breakpoints.down('sm')]: {
      padding: '0',
    },
  },
}));

export const ContainerSection = ({ position, anchor, title, children }) => {
  const classes = useStyle();

  return (
    <Box className={classes.wrap}>
      {position === 'left' ? (
        <div className={classes.root}>
          <Grid container id={anchor}>
            <Grid item xs={12} sm={5} md={4} lg={3}>
              <Text variant="h2" labelColor="primary" uppercase>
                <Trans>{title}</Trans>
              </Text>
            </Grid>
            <Grid item xs={12} sm={7} md={8} lg={9} className={classes.right}>
              {children}
            </Grid>
          </Grid>
        </div>
      ) : (
        <div className={classes.rootTop}>
          <Grid container id={anchor}>
            <Grid item xs={12}>
              <Text variant="h2" labelColor="primary" uppercase>
                <Trans>{title}</Trans>
              </Text>
            </Grid>
            <Divider height={50} />
            {/* <Grid container item xs={12}> */}
            {children}
            {/* </Grid> */}
          </Grid>
        </div>
      )}
    </Box>
  );
};

ContainerSection.defaultProps = {
  position: 'left',
};

ContainerSection.propTypes = {
  position: PropTypes.oneOf('top', 'left'),
  anchor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
